// Fire-and-forget event tracker. Wires into the 4 cost-first CTAs so the
// product team can see which affordability signal actually converts
// applicants.
//
// Design notes
// ------------
// - Absolutely no user-facing errors. Failed events are swallowed.
// - The backend allowlists 4 event names — anything else is silently
//   dropped server-side. We still centralise them here for grep-ability.
// - The `budget.slider_changed` firing is debounced so a single slider
//   drag emits at most one event per 800 ms.
//
// Usage
// -----
//     import { track, trackDebounced } from "@/lib/track";
//     track("shortlist.added", { degree_id, source: "advanced" });
//     trackDebounced("budget.slider_changed",
//                    { value, page: "/advanced", fits_count: 12 });

import { api } from "@/lib/api";

export const EVENTS = {
  PERSONAL_FIT_ADJUST: "personal_fit.adjust_weights",
  CONTINENTAL_ALT_CLICK: "continental.alt_clicked",
  BUDGET_SLIDER: "budget.slider_changed",
  SHORTLIST_ADDED: "shortlist.added",
};

export function track(name, props = {}) {
  try {
    api.post("/events", {
      name,
      props: props || {},
      page: typeof window !== "undefined" ? window.location.pathname : null,
    }).catch(() => {});
  } catch {
    /* swallow — instrumentation must never break UX */
  }
}

// Debounced tracker. Keyed by event name so each event has its own timer.
const _timers = new Map();
export function trackDebounced(name, props = {}, delayMs = 800) {
  const existing = _timers.get(name);
  if (existing) clearTimeout(existing);
  const t = setTimeout(() => {
    _timers.delete(name);
    track(name, props);
  }, delayMs);
  _timers.set(name, t);
}
